import React, { useState } from "react";
import Head from "next/head";
import ForgotPasswordForm from "components/ForgotPasswordForm";
import SuccessAnimation from "components/SuccessAnimation";
import { useFormattedMessage } from "hooks";
import { passwordRemindPage } from "i18n/messages/meta";

const messages = {
    forgotPassword: "forgot_password",
    forgotPasswordContent: "forgot_password_content",
    successAnimationContent: "request_submitted_successfully",
};

const PasswordRemindPage = () => {
    const { formatMessage } = useFormattedMessage();

    const [isFormSubmit, setFormSubmit] = useState(false);
    function formSubmitSuccess() {
        setFormSubmit(true);
        setTimeout(() => setFormSubmit(false), 5000);
    }
    return (
        <>
            <Head>
                <title>{formatMessage(passwordRemindPage.title)}</title>
            </Head>
            <div className="small-main password-remind-page">
                <div className="main-container text-center mw-600 mx-auto">
                    <h2>{formatMessage(messages.forgotPassword)}</h2>
                    <p className="my-5 text-16">{formatMessage(messages.forgotPasswordContent)}</p>
                    <section className="flex column forgot-password">
                        {!isFormSubmit ? (
                            <div className="form-holder border-none">
                                <ForgotPasswordForm formSubmitSuccess={formSubmitSuccess} />
                            </div>
                        ) : (
                            <SuccessAnimation
                                withContent
                                withContentTitle={false}
                                withContentDesc={formatMessage(messages.successAnimationContent)}
                                className="auth-common w-100 mt-0"
                            />
                        )}
                    </section>
                </div>
            </div>
        </>
    );
};

export default PasswordRemindPage;
